import Link from "next/link";

export default function SiteFooter() {
  return (
    <footer className="border-t border-[var(--stratus-border)] bg-[var(--background)] py-6">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-2 px-4 text-center text-sm text-[var(--stratus-muted)] sm:px-6">
        <p>&copy; {new Date().getFullYear()} Stratus. All rights reserved.</p>
        <Link
          href="/experimental-software-notice/"
          className="text-[var(--stratus-primary)] hover:underline"
        >
          Experimental software notice
        </Link>
      </div>
    </footer>
  );
}
